<picture>
  @if (useThumbnail) {
    <source [srcset]="image.thumbnail_image" />
  } @else {
    <source media="(min-width: 800px)" [srcset]="image.medium_image" />
    <source media="(max-width: 799px)" [srcset]="image.small_image" />
  }
  <img [style.object-fit]="objectFit" [src]="image.image" />
</picture>
